import { track } from "jiffy-analytics";
import EventClass from "common/utils/ui/event-class";
import "./digital-assets-filters-color/digital-assets-filters-color";
import "./digital-assets-filters.scss";

export class DigitalAssetsFilters extends EventClass {
  constructor(props) {
    super({
      eventSelector: props.eventSelector,
      event: "submit"
    });
  }

  // eslint-disable-next-line class-methods-use-this
  event(_, $form) {
    const { totalResults, pageName, digitalAssetsFilters } = $form.dataset;
    const formData = new FormData($form);

    track("digital_asset_filter_applied", {
      results_count: totalResults,
      page_name: pageName,
      old_filters: JSON.parse(digitalAssetsFilters),
      new_filters: Array.from(formData.keys()).reduce((acc, key) => {
        const [filter, brakes] = key.split("[]");
        if (typeof brakes === "string") acc[filter] = formData.getAll(key);
        return acc;
      }, {})
    });
  }
}

export default () => new DigitalAssetsFilters({ eventSelector: ".js-digital-assets-filters" });
